import Input from '@vromo/ui/components/Input';
import React, { ChangeEventHandler, memo } from 'react';
import { FilterRow } from '../../reportFilterModal.style';
import { qaLabelReports } from '../../../../../../../../common-qa-labels/reports'
interface Props {
    label: string;
    placeholder: string;
    value: string;
    onChange: ChangeEventHandler<HTMLInputElement>;
}

const FilterInput = ({ label, placeholder, value, onChange }: Props) => (
    <FilterRow>
        <label>{label}</label>
        <div style={{ flex: 5 }}>
            <Input data-testid={qaLabelReports.jobNameInput} type="text" placeholder={placeholder} value={value} onChange={onChange} />
        </div>
    </FilterRow>
);

export default memo(FilterInput);
